export class IWorkdayCurrent {
  currentWorkday: number;
}
